var _style, _defs, _defs2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\r\n\t\t.st0{clip-path:url(#SVGID_00000151538415186868208020000014258193397046824620_);fill:url(#SVGID_00000017481216336162747200000011008546092713337226_);}\r\n\t.st1{clip-path:url(#SVGID_00000093172294073167906810000008896315841633918369_);fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 12,
    cy: 12,
    r: 12
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000154389334364286940960000003441607438687969435_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043416888194073190080000009535091020996787864_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 24,
    x2: 1,
    y2: 24,
    gradientTransform: "matrix(17.0533 -17.0533 17.0533 17.0533 -406.4171 -388.1429)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEE411"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0518,
    style: {
      stopColor: "#FEDB16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1381,
    style: {
      stopColor: "#FEC125"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2481,
    style: {
      stopColor: "#FE983D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    style: {
      stopColor: "#FE5F5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FE2181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9000DC"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000154389334364286940960000003441607438687969435_)",
      fill: "url(#SVGID_00000043416888194073190080000009535091020996787864_)"
    },
    points: " 12,36 36,12 12,-12 -12,12  "
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000154407118468236915170000002141837832107315357_",
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067942313215971218600000008787438372303998856_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000154407118468236915170000002141837832107315357_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000067942313215971218600000008787438372303998856_)",
      fill: "#FFFFFF"
    },
    d: "M14.55,5.33H9.46 c-2.27,0-4.12,1.84-4.12,4.12v5.09c0,2.27,1.85,4.12,4.12,4.12h5.09c2.27,0,4.12-1.85,4.12-4.12V9.45 C18.67,7.18,16.82,5.33,14.55,5.33 M17.18,14.55c0,1.45-1.18,2.63-2.64,2.63H9.45c-1.45,0-2.63-1.18-2.63-2.63V9.46 c0-1.45,1.18-2.64,2.63-2.64h5.09c1.45,0,2.64,1.18,2.64,2.64V14.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000067942313215971218600000008787438372303998856_)",
      fill: "#FFFFFF"
    },
    d: "M12,8.59 c-1.88,0-3.41,1.53-3.41,3.41c0,1.88,1.53,3.41,3.41,3.41s3.41-1.53,3.41-3.41C15.41,10.12,13.88,8.59,12,8.59 M12,14.07 c-1.14,0-2.07-0.93-2.07-2.07c0-1.14,0.93-2.07,2.07-2.07s2.07,0.93,2.07,2.07C14.07,13.14,13.14,14.07,12,14.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000067942313215971218600000008787438372303998856_)",
      fill: "#FFFFFF"
    },
    d: "M15.48,7.83 c0.31-0.05,0.61,0.16,0.66,0.48s-0.16,0.61-0.48,0.66c-0.31,0.05-0.61-0.16-0.66-0.48C14.96,8.18,15.17,7.88,15.48,7.83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.06920b96196e1db40aa27f21fb6378e6.svg";
export { ForwardRef as ReactComponent };